import { render, staticRenderFns } from "./ConfigDesktop.vue?vue&type=template&id=99b32ac6&"
import script from "./ConfigDesktop.vue?vue&type=script&lang=js&"
export * from "./ConfigDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDesktop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports